import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_ON_CHANGE_VEHICLE_STATE = `${VEHICLE_MODULE_PREFIX}_ON_CHANGE_VEHICLE_STATE`;
/**
 * Action to update specific property (pinVid, nadaVid, redbookControlNumber) of Vehicle State
 * Using this action in VehicleAttribute component to update the value of pinVid, nadaVid or redbookControlNumber
 * @param payload { name: string, value: VehicleChangeValue }
 * @returns
 */
export const vehicleChangeStateAction = (payload) => ({
    type: VEHICLE_ON_CHANGE_VEHICLE_STATE,
    payload
});
//# sourceMappingURL=changeVehicleStateActions.js.map